export let outlets = [];
export function sliceOutlets(index) {
    outlets = outlets.slice(0, index);
}
